import { render } from "./DateItem.vue?vue&type=template&id=2d879016&scoped=true"
import script from "./DateItem.vue?vue&type=script&lang=js"
export * from "./DateItem.vue?vue&type=script&lang=js"

import "./DateItem.vue?vue&type=style&index=0&id=2d879016&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d879016"]])

export default __exports__